import { Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./IntervalRange.styles";
import * as React from "react";
import { FormDateField } from "../FormComponents/FormDateField";


export interface IIntervalRangeProps extends WithStyles<typeof styles> {
    from: string;
    to: string;
    firstAvailableDate?: string;
    lastAvailableDate?: string;
    onChange: any;
    disabled?: boolean;
    translation?: any;
}

const IntervalRangePure: React.FunctionComponent<IIntervalRangeProps> = ({
                                                                             from,
                                                                             to,
                                                                             firstAvailableDate,
                                                                             lastAvailableDate,
                                                                             onChange,
                                                                             disabled,
                                                                             translation,
                                                                             classes
                                                                         }: IIntervalRangeProps) => {


    return <>
        <div className={classes.sectionInput}>
            <Typography variant={"caption"}>Date from</Typography>
            <FormDateField
                placeholder={translation ? translation("general.from") : "From"}
                disabled={disabled}
                value={from}
                firstAvailableDate={firstAvailableDate}
                lastAvailableDate={lastAvailableDate}
                onChange={(value) => onChange(value, to)}
            />
            <br/>
            <Typography variant={"caption"}>Date to</Typography>
            <FormDateField
                placeholder={translation ? translation("general.to") : "To"}
                disabled={disabled}
                value={to}
                firstAvailableDate={firstAvailableDate}
                lastAvailableDate={lastAvailableDate}
                onChange={(value) => onChange(from, value)}
            />
        </div>
    </>;
};

export const IntervalRange = withStyles(styles)(IntervalRangePure);
